import React, { Suspense } from 'react';
import Navbar from './Navbar';
import NotificationSidebar from './NotificationSidebar';
import { useAuth } from '../contexts/AuthContext';
import { Navigate } from 'react-router-dom';

interface MainLayoutProps {
    children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
    const { isAuthenticated, user } = useAuth();

    if (!isAuthenticated) {
        return <Navigate to="/login" />;
    }

    // Clients should never be in MainLayout (which is for OSGB staff)
    if (user?.role === 'client') {
        return <Navigate to="/client/dashboard" />;
    }

    // CRITICAL SECURITY: Expert/Doctor users MUST NOT access admin dashboard
    // They must use /field or /web/field interfaces only
    if (user?.role === 'expert' || user?.role === 'doctor') {
        return <Navigate to="/web/field/login" />;
    }

    return (
        <div className="main-layout">
            <Navbar />
            <NotificationSidebar />
            <main className="main-content">
                <Suspense fallback={<div>Yükleniyor...</div>}>
                    {children}
                </Suspense>
            </main>
        </div>
    );
};

export default MainLayout;
